
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getMainworkorderstatus = async () => {
  return await get<ApiResponse<any[]>>("/mainworkorderstatus").then((res)=>{
      return res
    })
};

 